/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */
import React from 'react';
import { useSelector } from 'react-redux';

import './RMDTableNew.scss';

import TableHeaderNew from './TableHeaderNew';
import TableBodyNew from './TableBodyNew';
import { getRMDSummary } from '../../../redux/modules/RMD/RMDSetting.selectors';
import { currency } from '../../../utils/dashboard-utils';
import TableTotal from './TableTotal';

const RMDTableNew = () => {
  const rmdSummary = useSelector(getRMDSummary);
  const showYTDColumns = rmdSummary.displayDistributionColumns;
  const pagination = rmdSummary.pagination || {};
  const currentRmdYear = rmdSummary.rmdYear;
  const totalBalance = currency(rmdSummary.totalBalance);
  const totalRMD = currency(rmdSummary.totalRMD);
  const retirementPlans = rmdSummary.retirementPlans || [];
  return (
    <div>
      <div id="RMD-Table-New" >
        <table>
      {retirementPlans.map((agreements) => (
        <>
            {agreements.agreementTypeContainers.map((fund ) => (
              <>
                <TableHeaderNew
                  showYTDColumns={showYTDColumns || null}
                  currentRmdYear={currentRmdYear || null}
                  totalBalance={totalBalance || null}
                  totalRMD={totalRMD || null}
                  rmdSummary={rmdSummary || null}
                  retirementPlans={fund}
                />
                <TableBodyNew
                  showYTDColumns={showYTDColumns || null}
                  retirementPlans={fund}
                  pagination={pagination}
                  handleClick={(e) => {
                    showMore(e);
                  }}
                />
              </>
            ))}

       </>
      ))}
          <TableTotal
            showYTDColumns={showYTDColumns || null}
            currentRmdYear={currentRmdYear || null}
            totalBalance={totalBalance || null}
            totalRMD={totalRMD || null}
            rmdSummary={rmdSummary || null}
            retirementPlans={retirementPlans}
          />
        </table>
        </div>
    </div>
  );
};

export default RMDTableNew;
